import { ReactElement } from "react";
import { Accordion } from "../accordion";
import styles from "./faq.module.scss";

export const Faq = (props: Props): ReactElement => {
  return (
    <section className={styles.base}>
      {(props.title || props.description) && (
        <div className={styles.wrapper}>
          {props.title && <p className={styles.title}>{props.title}</p>}
          {props.description && (
            <p className={styles.description}>{props.description}</p>
          )}
        </div>
      )}

      <Accordion accordionItems={props.faqItems} />

      {props.communicationsComponent}
    </section>
  );
};

interface Props {
  title?: string;
  description?: string;
  faqItems: { title: string; content: string }[];
  communicationsComponent?: JSX.Element;
}
